<!--
  ~ VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="common-dialog-component owncloud-upload-dialog">
  <vnc-dialog [classes]="isMobileSize ? ['common-dialog', 'mobile-size'] : ['common-dialog']" [headerTemplate]="headerTemplate"
    [footerTemplate]="footerTemplate" [bodyTemplate]="bodyTemplate">
  </vnc-dialog>
  <ng-template #bodyTemplate>
    <div class="content-wrapper">
      <div class="owncloud-navigation">
        <div class="home-icon">
          <vnc-icon-container (click)="home()">
            <ng-container [ngTemplateOutlet]="homeIcon">
            </ng-container>
          </vnc-icon-container>
          <span class="home-folder" (click)="home()">VNCProject</span>
        </div>
        <ng-container *ngIf="currentFolder">
          <div class="separator-icon">
            <ng-container [ngTemplateOutlet]="separatorIcon">
            </ng-container>
          </div>
          <div class="more-text" (click)="backPreviousFolder()">
            ...
          </div>
          <div class="separator-icon">
            <ng-container [ngTemplateOutlet]="separatorIcon">
            </ng-container>
          </div>
          <div class="current-folder">
            {{ currentFolder?.name }}
          </div>
        </ng-container>
        <div class="ui-progressbar" *ngIf="(uploading | async)">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          {{ 'SENDING_FILE_TO_OWNCLOUD' | translate }}
        </div>
      </div>
      <div class="owncloud-files vnc-scroll-bar--small--vertical">
        <div *ngIf="isLoading" class="loading-attachments">
          <vnc-loader-circular color="blue" size="m"></vnc-loader-circular>
        </div>
        <vp-dropdown-item class="is-edited" *ngIf="newFolder" (saveClicked)="renameFolder($event)" (cancelClicked)="cancelRename()" [isEdited]="true" [element]="newFolder" itemType="owncloud-item"
         [label]="newFolder?.name">
        </vp-dropdown-item>
        <vp-dropdown-item *ngFor="let file of files$ | async" [element]="file" itemType="owncloud-item"
        [fileAuther]="file.ownerDisplayName"
        (iconClicked)="openFolder(file)"
        (descriptionClicked)="openFolder(file)"
         (arrowIconClicked)="openFolder(file)" [customMetaTemplate]="customMetaTemplate" [label]="file.name">
        </vp-dropdown-item>
        <div *ngIf="!(files$ | async).length && isLoading == false" class="isEmpty">
          {{'THIS_FOLDER_IS_EMPTY' | translate}}
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #headerTemplate>
    <vnc-header *ngIf="!isMobileSize" style="width:100%;" title="{{ 'SEND_TO_OWNCLOUD' | translate }}" type="title-close" size="l"
      (onCloseClick)="cancel()" [showCloseIcon]="true" closeIconToolTip="{{'CLOSE' | translate}}">
    </vnc-header>
    <vnc-mobile-header *ngIf="isMobileSize" style="width: 100%" (darkSuffixButtonPress)="send()"
    (darkBackPress)="cancel()"  darkSuffixIcon="mdi-check"
    (onPrefixIconClick)="createFolder()"
    [prefixIconTemplate]="newFolderIcon"
    headerType="dark-back-more" darkBackMorePlaceHolder="{{ 'SEND_TO_OWNCLOUD' | translate }}"></vnc-mobile-header>

  </ng-template>
  <ng-template #footerTemplate>
    <vnc-footer *ngIf="!isMobileSize" style="width: 100%;" (onActionLinkClick)="createFolder()" [leadingIconTemplate]="leadIconTemplate" linkLabel="{{ 'CREATE_A_FOLDER' | translate }}"
      secondaryLabel="{{ 'CANCEL' | translate }}" primaryLabel="{{ 'SEND' | translate }}"
      (onActionLinkClick)="createFolder()" (onPrimaryClick)="send()" (onSecondaryClick)="cancel()"
      [type]="'actionlink-secondary-primary'" [color]="'white'"></vnc-footer>
  </ng-template>
  <ng-template #leadIconTemplate>
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <filter x="-14.4%" y="-11.3%" width="128.8%" height="122.6%" filterUnits="objectBoundingBox" id="filter-1">
          <feOffset dx="0" dy="8" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.031372549   0 0 0 0 0.176470588   0 0 0 0 0.239215686  0 0 0 0.2 0"
            type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
          <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
          <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.0311856736   0 0 0 0 0.177658465   0 0 0 0 0.240432518  0 0 0 0.1 0"
            type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g id="Chats" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="0240.-VNCtalk--Chats--Owncloud-#14" transform="translate(-714.000000, -1235.000000)" fill="#337CBD">
          <g id="Group-9" transform="translate(191.000000, 24.000000)">
            <g id="Group-13" transform="translate(504.000000, 635.000000)" filter="url(#filter-1)">
              <g id="Footer/white/actionlink-secondary-primary" transform="translate(0.000000, 559.000000)">
                <g id="Actionlink/@blue/icon-left/default" transform="translate(16.000000, 14.000000)">
                  <g id="Icon/product/folder-add-new" transform="translate(3.000000, 3.000000)">
                    <g id="Icon-24px" transform="translate(1.500000, 3.000000)">
                      <path
                        d="M5.25691652,0 C5.62496388,0 6.13519446,0.197241658 6.44611277,0.454294611 L6.53306741,0.533067405 L6.96693259,0.966932595 C7.23847114,1.23847114 7.7335401,1.45685481 8.13158907,1.49431682 L8.2477726,1.5 L13.5,1.5 C14.2875,1.5 14.9383264,2.11503099 14.9958654,2.88847906 L15,3 L15,10.5 C15,11.2875 14.384969,11.9383264 13.6115209,11.9958654 L13.5,12 L1.5,12 C0.7125,12 0.0616735537,11.384969 0.00413457926,10.6115209 L0,10.5 L0.0075,1.5 C0.0075,0.7125 0.615697314,0.0616735537 1.38852414,0.00413457926 L1.5,0 L5.25691652,0 Z M5.25691652,1.5 L1.50749948,1.50125 L1.5,10.5 L13.5,10.5 L13.5,3 L8.2477726,3 C7.48880238,3 6.61064626,2.65670176 6.02674057,2.14073726 L5.90627242,2.02759277 L5.47240723,1.59372758 L5.45266581,1.58245704 L5.31352583,1.52152998 L5.25691652,1.5 Z M5.25,3.75 C5.66421356,3.75 6,4.08578644 6,4.5 L6,5.625 L7.125,5.625 C7.53921356,5.625 7.875,5.96078644 7.875,6.375 C7.875,6.78921356 7.53921356,7.125 7.125,7.125 L6,7.125 L6,8.25 C6,8.66421356 5.66421356,9 5.25,9 C4.83578644,9 4.5,8.66421356 4.5,8.25 L4.5,7.124 L3.375,7.125 C2.96078644,7.125 2.625,6.78921356 2.625,6.375 C2.625,5.96078644 2.96078644,5.625 3.375,5.625 L4.5,5.624 L4.5,4.5 C4.5,4.08578644 4.83578644,3.75 5.25,3.75 Z"
                        id="Combined-Shape"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ng-template>

</div>

<ng-template #homeIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <defs>
      <filter id="873ldqrm0a" color-interpolation-filters="auto">
        <feColorMatrix in="SourceGraphic"
          values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0" />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g filter="url(#873ldqrm0a)"
              transform="translate(-222.000000, -347.000000) translate(215.000000, 340.000000) translate(4.000000, 4.000000) translate(3.000000, 3.000000)">
              <g fill="#8B96A0">
                <path
                  d="M6 12.75L6 8.25 9 8.25 9 12.75 12.75 12.75 12.75 6.75 15 6.75 7.5 0 0 6.75 2.25 6.75 2.25 12.75z"
                  transform="translate(1.500000, 2.250000)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>

<ng-template #customMetaTemplate let-file="file">
  <div class="auther">
    <span class="star-icon" (click)="addToFavorite(file)" *ngIf="!file.starred">
      <ng-container [ngTemplateOutlet]="unstarIcon">
      </ng-container>
    </span>
    <span class="star-icon" (click)="removeFromFavorite(file)" *ngIf="file.starred">
      <ng-container [ngTemplateOutlet]="starIcon">
      </ng-container>
    </span>
    {{file.ownerDisplayName}}</div>
  <div class="file-date-time"> | {{ getFileSize(file.size) }} | {{getTimeAgo(file?.lastModified)}} </div>
</ng-template>
<ng-template #separatorIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g fill="#606B76">
        <g>
          <g>
            <path d="M14 6L15 6 11 18 10 18z"
              transform="translate(-320.000000, -344.000000) translate(250.000000, 344.000000) translate(70.000000, 0.000000)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>


<ng-template #unstarIcon>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <filter x="-14.4%" y="-11.3%" width="128.8%" height="122.6%" filterUnits="objectBoundingBox" id="filter-1">
            <feOffset dx="0" dy="8" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.031372549   0 0 0 0 0.176470588   0 0 0 0 0.239215686  0 0 0 0.2 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.0311856736   0 0 0 0 0.177658465   0 0 0 0 0.240432518  0 0 0 0.1 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
            </feMerge>
        </filter>
    </defs>
    <g id="Chats" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="0240.-VNCtalk--Chats--Owncloud-#14" transform="translate(-251.000000, -123.000000)" fill="#8B96A0">
            <g id="Group-13" transform="translate(191.000000, 24.000000)" filter="url(#filter-1)">
                <g id="Group-10" transform="translate(0.000000, 62.000000)">
                    <g id="Group" transform="translate(60.000000, 35.000000)">
                        <g id="Icon/product/favorites-new" transform="translate(0.000000, 2.000000)">
                            <g id="Icon-24px" transform="translate(0.752836, 0.770384)">
                                <path d="M3.4991643,3.07161552 L0.704765465,3.30899638 L0.632301786,3.31759392 C-0.0276027278,3.41897253 -0.224587015,4.10246502 0.299372893,4.55637168 L2.4216643,6.39461552 L1.78425607,9.12727692 L1.77045565,9.19647203 C1.66141037,9.85660366 2.25080069,10.2571133 2.84518306,9.89836796 L5.2471643,8.44861552 L7.64914554,9.89836796 L7.710702,9.93285706 C8.30493881,10.2403775 8.86779211,9.80335536 8.71007253,9.12727692 L8.0721643,6.39461552 L10.1949557,4.55637168 L10.2484478,4.50680547 C10.7220638,4.03673539 10.4808081,3.36764164 9.78956313,3.30899638 L6.9946643,3.07161552 L5.90288248,0.49543764 C5.62262546,-0.165809335 4.87114061,-0.164482092 4.59144612,0.49543764 L3.4991643,3.07161552 Z M4.18486474,4.01733703 L5.2471643,1.51011552 L6.30946386,4.01733703 L9.0241643,4.24761552 L6.96167568,6.03430768 L7.5811643,8.68911552 L5.2471643,7.28060257 L2.9126643,8.68911552 L3.53265292,6.03430768 L1.4696643,4.24761552 L4.18486474,4.01733703 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</ng-template>

<ng-template #starIcon>
  <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
    <path d="m4.252 3.842-2.794.237-.073.009c-.66.101-.857.785-.333 1.239l2.123 1.838-.638 2.733-.014.069c-.109.66.48 1.06 1.075.702L6 9.219l2.402 1.45.062.034c.594.308 1.157-.13.999-.805l-.638-2.733 2.123-1.838.053-.05c.474-.47.233-1.139-.459-1.198l-2.794-.237-1.092-2.576c-.28-.661-1.032-.66-1.312 0L4.252 3.842z" fill="#FFAD16" fill-rule="evenodd"/>
  </svg>
</ng-template>

<ng-template #newFolderIcon>

<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.01 4c.49 0 1.17.263 1.585.606l.116.105.578.578c.362.362 1.022.653 1.553.703l.155.008H20c1.05 0 1.918.82 1.994 1.851L22 8v10c0 1.05-.82 1.918-1.851 1.994L20 20H4c-1.05 0-1.918-.82-1.994-1.851L2 18l.01-12c0-1.05.81-1.918 1.841-1.994L4 4h5.01zm0 2-5 .002L4 18h16V8h-7.003c-1.012 0-2.183-.458-2.961-1.146l-.161-.15-.578-.579-.027-.015-.185-.081L9.009 6zM9 9a1 1 0 0 1 1 1v1.5h1.5a1 1 0 0 1 0 2H10V15a1 1 0 0 1-2 0v-1.5H6.5a1 1 0 1 1 0-2H8V10a1 1 0 0 1 1-1z" fill="#FFF" fill-rule="evenodd"/>
</svg>

</ng-template>
